module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./RechargeListView.js"));
	}, "RechargeListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RechargeListView!./src/pages/Shop/Member/Wallet/Refund/RechargeList/RechargeListView.js
// module id = 1086
// module chunks = 431